// constants
const SET_LOADING_FOR_ALL_SYNC_BUTTONS = "SET_LOADING_FOR_ALL_SYNC_BUTTONS";

// actions
export const setLoadingForAllSyncButtons = (payload) => ({
  type: SET_LOADING_FOR_ALL_SYNC_BUTTONS,
  payload,
});

// reducer
const initialState = {
  allSyncButtonsLoader: false,
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LOADING_FOR_ALL_SYNC_BUTTONS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
